<template>
    <div
        v-if="!route.path.includes('newsletter')"
        class="m-auto px-4 py-20 lg:flex lg:justify-center lg:items-center lg:gap-5 bg-base-200"
    >
        <div class="flex flex-col items-center lg:max-w-[768px] xl:max-w-[640px] 2xl:max-w-[768px]">
            <ClientOnly>
                <div class="newsletter-headline text-4xl uppercase font-normal text-base-content font-fjalla-one text-center">
                    {{ $t('layout.footerNewsletter.title', { discount: formattedDiscount }) }}
                </div>
                <template #fallback>
                    <div class="w-full min-h-[45px]" />
                </template>
            </ClientOnly>
            <div class="newsletter-subtitle text-center text-base-content text-lg mb-9 mt-2">
                {{ $t('layout.footerNewsletter.subtitle') }}
            </div>
            <NewsletterSubscribe />
        </div>
    </div>
</template>

<script setup lang="ts">
const route = useRoute()
const { sessionContext } = useSessionContext()
const { getFormattedPrice } = usePrice()

const discountAmountsByShippingCountry = ref<Record<string, number>>({
    '23f1e3a2eba64c5197e47e7e5e41e785': 15, // CH - Switzerland (CHF)
    'd1f39aad6c554a3183d35ba7a339a963': 15, // LI - Liechtenstein (CHF, same as CH)
    'cf949571b0ec4c8badf1fe72e113551b': 170, // SE - Sweden (SEK)
    '56ff618e238148ceac926cee50bfacbf': 110, // DK - Denmark (DKK)
    '0496f34fc43f4734afe6de8f86cbad06': 65, // PL - Poland (PLN)
    'e8cb959a1c014e00a4c348d5fb4f037d': 360, // CZ - Czech Republic (CZK)
    '9feacc46dc1549f98d4a4699bf5d1d9d': 170, // NO - Norway (NOK)
    'fallback': 15 // EUR countries
})

const formattedDiscount = computed(() => {
    const currentShippingCountryId = sessionContext.value?.shippingLocation?.country?.id
    const discountAmount = currentShippingCountryId != null && discountAmountsByShippingCountry.value[currentShippingCountryId] != null ?
        discountAmountsByShippingCountry.value[currentShippingCountryId] :
        discountAmountsByShippingCountry.value.fallback
    
    return getFormattedPrice(discountAmount)
})
</script>
